import { useCallback } from "react"
import { useFetch } from "utils/fetch"

export const useGetData = (path) => {
  const { getData } = useFetch()
  return useCallback((params) => getData(typeof path === "function" ? path(params) : path, params), [getData, path])
}

export const usePostData = (path) => {
  const { postData } = useFetch()
  return useCallback((data) => postData(typeof path === "function" ? path(data) : path, data), [postData, path])
}

export const useDeleteData = (path) => {
  const { deleteData } = useFetch()
  return useCallback((data) => deleteData(typeof path === "function" ? path(data) : path, data), [deleteData, path])
}

export const usePutData = (path) => {
  const { putData } = useFetch()
  return useCallback((data) => putData(typeof path === "function" ? path(data) : path, data), [putData, path])
}

export const useUploadFile = (path, method = "post") => {
  const { postData, putData } = useFetch()
  return useCallback(
    (file, params) => {
      const form = new FormData()
      form.append((params && params.field) || "formFiles", file, file.name)
      return method === "post"
        ? postData(typeof path === "function" ? path(params) : path, null, { headers: {}, body: form })
        : putData(`${path}?${new URLSearchParams(params).toString()}`, null, { headers: {}, body: form })
    },
    [method, postData, putData, path],
  )
}
